(function(){
  const banner = document.querySelector('.halloween-banner');
  if (!banner) return;

  // Ghosts
  const style = document.createElement('style');
  style.textContent = `@keyframes hb-ghost-move{from{transform:translateX(0)}to{transform:translateX(130vw)}}`;
  document.head.appendChild(style);
  const ghostCount = 9;
  for (let i=0;i<ghostCount;i++){
    const g = document.createElement('div');
    g.className = 'hb-ghost'; g.textContent = '👻';
    g.style.top = (20 + Math.random()*60) + '%';
    g.style.left = (-10 - Math.random()*10) + '%';
    const dur = 10 + Math.random()*8;
    g.style.animation = `hb-ghost-move ${dur}s linear infinite`;
    g.style.animationDelay = (Math.random()*dur) + 's';
    banner.appendChild(g);
  }

  // Lights
  const lights = 6;
  for (let i=0;i<lights;i++){
    const l = document.createElement('div');
    l.className = 'hb-light';
    l.style.left = (5 + Math.random()*90) + '%';
    l.style.top = (70 + Math.random()*20) + '%';
    l.style.animationDelay = (Math.random()*1.5) + 's';
    banner.appendChild(l);
  }

  // Fog
  const fog = document.createElement('div');
  fog.className = 'hb-fog';
  banner.appendChild(fog);

  // Rain + lightning canvases
  const c1 = Object.assign(document.createElement('canvas'), { id:'hb-c1', className:'hb-canvas' });
  const c2 = Object.assign(document.createElement('canvas'), { id:'hb-c2', className:'hb-canvas' });
  const c3 = Object.assign(document.createElement('canvas'), { id:'hb-c3', className:'hb-canvas' });
  banner.append(c1,c2,c3);

  const ctx1=c1.getContext('2d'), ctx2=c2.getContext('2d'), ctx3=c3.getContext('2d');
  let w=c1.width=c2.width=c3.width=banner.clientWidth;
  let h=c1.height=c2.height=c3.height=banner.clientHeight;

  function onResize(){
    w=c1.width=c2.width=c3.width=banner.clientWidth;
    h=c1.height=c2.height=c3.height=banner.clientHeight;
  }
  window.addEventListener('resize', onResize);

  // Data
  const rainthroughnum=200, rainnum=220, speedRainTrough=20;
  const RainTrough=[], rain=[], lightning=[];
  const R = (min,max)=>Math.random()*(max-min)+min;

  for(let i=0;i<rainthroughnum;i++)
    RainTrough.push({x:R(0,w),y:R(0,h),length:Math.floor(R(1,830)),
      opacity:Math.random()*0.2,xs:R(-2,2),ys:R(10,20)});
  for(let i=0;i<rainnum;i++)
    rain.push({x:Math.random()*w,y:Math.random()*h,l:Math.random()*1,
      xs:-4+Math.random()*4+2,ys:Math.random()*10+10});

  function drawTrough(r){
    const g=ctx1.createLinearGradient(0,r.y,0,r.y+r.length);
    g.addColorStop(0,'rgba(255,255,255,0)');
    g.addColorStop(1,`rgba(255,255,255,${r.opacity})`);
    ctx1.fillStyle=g; ctx1.fillRect(r.x,r.y,1,r.length);
  }
  function drawDrop(d){
    ctx2.beginPath(); ctx2.moveTo(d.x,d.y);
    ctx2.lineTo(d.x+d.l*d.xs, d.y+d.l*d.ys);
    ctx2.strokeStyle='rgba(174,194,224,0.5)'; ctx2.lineWidth=1; ctx2.stroke();
  }

  function createLightning(){
    const x=R(100,w-100), y=R(0,h/4), count=Math.floor(R(1,3));
    for(let i=0;i<count;i++)
      lightning.push({x,y,xRange:R(5,30),yRange:R(10,25),path:[{x,y}],pathLimit:R(40,55)});
  }
  function drawLightning(){
    for(let i=0;i<lightning.length;i++){
      const L=lightning[i], last=L.path[L.path.length-1];
      L.path.push({ x:last.x+(R(0,L.xRange)-(L.xRange/2)), y:last.y+R(0,L.yRange) });
      if(L.path.length>L.pathLimit){ lightning.splice(i,1); i--; continue; }
      ctx3.strokeStyle='rgba(255,255,255,.2)'; ctx3.lineWidth=2+Math.random()*4;
      ctx3.beginPath(); ctx3.moveTo(L.x,L.y); L.path.forEach(p=>ctx3.lineTo(p.x,p.y)); ctx3.stroke();
      if(Math.floor(R(0,30))===1){ ctx3.fillStyle=`rgba(255,255,255,${R(.01,.03)})`; ctx3.fillRect(0,0,w,h); }
    }
  }

  let tick=0;
  (function loop(){
    // troughs
    ctx1.clearRect(0,0,w,h);
    for(const r of RainTrough){ r.y = (r.y>=h? 0 : r.y+speedRainTrough); drawTrough(r); }
    // drops
    ctx2.clearRect(0,0,w,h);
    for(const d of rain){ d.x+=d.xs; d.y+=d.ys; if(d.x>w||d.y>h){d.x=Math.random()*w; d.y=-20;} drawDrop(d); }
    // lightning (fade)
    ctx3.globalCompositeOperation='destination-out';
    ctx3.fillStyle='rgba(0,0,0,0.02)'; ctx3.fillRect(0,0,w,h);
    ctx3.globalCompositeOperation='source-over';
    if(++tick % 200 === 0) createLightning();
    drawLightning();
    requestAnimationFrame(loop);
  })();
})();
